import comSpSkeleton from "../../../../engines/components/comSpSkeleton";

const {ccclass, property} = cc._decorator;

@ccclass
export default class eggSynthesisPage extends cc.Component {

    @property({type:comSpSkeleton,displayName:"蛋的动画"})
    eggAni:comSpSkeleton = null;

    @property({type:comSpSkeleton,displayName:"云的动画"})
    cloudAni:comSpSkeleton = null;

    start(){
        this.cloudAni.playAnimation("animation").start(false);
        this.scheduleOnce(()=>{
            this.eggAni.playAnimation("animation").onComplete(1,()=>{}).start(true);
            this.scheduleOnce(()=>{
                this.closeThis();
            },2);
        },1.2);
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }
    
}
